import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { StoreSpecificConfigService } from '@scalefast/config-angular';
import { priceSpecs, ProductPrice } from '@scalefast/core';
import { CrossedPriceManager } from 'src/app/core/classes/CrossedPriceManager';

@Component({
  standalone: true,
  imports: [],
  template: '',
})
export class AppOptionsPriceBaseComponent implements OnInit, OnChanges {
  @Input() productPriceInfo: ProductPrice | undefined;
  @Input() feedId: string | string[] | undefined;
  @Input() bundleRecommendedPricesProducts: any | undefined;

  private storeSpecificConfigService = inject(StoreSpecificConfigService);

  offerFeed: string | undefined;
  isOfferFeed: boolean = true;
  hideCrossedPrice: boolean = false;
  bundleCrossedPriceIsRecommendedPrice: boolean = false;
  crossedPriceManager: CrossedPriceManager = new CrossedPriceManager();

  constructor() {
    let specificConfig = this.storeSpecificConfigService.get();
    this.hideCrossedPrice = specificConfig.hideCrossedPrice;
    this.bundleCrossedPriceIsRecommendedPrice = specificConfig.bundleCrossedPriceIsRecommendedPrice;
    this.offerFeed = specificConfig.offerFeed;
  }

  ngOnInit(): void {
    this.update();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  protected update() {
    this.crossedPriceManager.setConfig(
      this.bundleRecommendedPricesProducts,
      this.bundleCrossedPriceIsRecommendedPrice,
      this.priceInfo,
    );
    this.crossedPriceManager.calculateCrossedPrice();

    if (this.hideCrossedPrice && this.offerFeed) {
      this.isOfferFeed = this.feedId?.includes(this.offerFeed) ?? false;
    }
  }

  get showCrossedPrice(): boolean {
    return this.hasDiscount && (!this.hideCrossedPrice || (this.hideCrossedPrice && this.isOfferFeed));
  }

  get superHasDiscount(): boolean {
    if (!this.priceInfo || !this.priceInfo.oldPrice) {
      return false;
    }
    return this.priceInfo.oldPrice > this.priceInfo.price;
  }

  get hasDiscount(): boolean {
    if (this.crossedPriceManager.bundleOldPrice) {
      return (this.crossedPriceManager.bundleOldPrice ?? this.priceInfo?.oldPrice) !== 0
        ? this.crossedPriceManager.bundleOldPrice! > (this.priceInfo?.price ?? 0)
        : false;
    } else if (
      this.crossedPriceManager.bundleOldPrice! === 0 &&
      this.priceInfo?.oldPrice !== undefined &&
      this.priceInfo?.oldPrice === 0
    ) {
      return true;
    }

    const oldPrice = this.parsePrice(this.priceInfo?.oldPrice);
    const currentPrice = this.parsePrice(this.priceInfo?.price);

    return (!isNaN(oldPrice) && !isNaN(currentPrice) && oldPrice > currentPrice) || this.superHasDiscount;
  }

  get priceInfo(): priceSpecs | undefined {
    return this.productPriceInfo?.currencies.filter(
      (item: { currency: string; prices: Array<priceSpecs> }) => item.currency == this.productPriceInfo?.currency,
    )[0].prices[0];
  }

  protected parsePrice(value: string | number | undefined): number {
    if (typeof value === 'string') {
      return parseFloat(value);
    }
    return value ?? 0;
  }
}
